export function maskIdentifier(value) {
  if (!value) return ''

  if (value.includes('@')) {
    const [local, domain] = value.split('@')
    const visible = local.slice(0, Math.min(2, local.length))
    return `${visible}****@${domain}`
  }

  const digits = value.replace(/\D/g, '')
  if (digits.length >= 7) {
    return value.replace(/(\d{3})[\d\-\s]+(\d{4})/, '$1****$2')
  }

  return value
}
